import {
  Alert,
  AlertVariant,
  Button,
  ButtonVariant,
  Checkbox,
  Modal,
  ModalVariant,
  Stack,
  StackItem,
  Text,
  TextContent
} from "../_snowpack/pkg/@patternfly/react-core.js";
import FileSaver from "../_snowpack/pkg/file-saver.js";
import React, {useState} from "../_snowpack/pkg/react.js";
import {useTranslation} from "../_snowpack/pkg/react-i18next.js";
import {useAlerts} from "../components/alert/Alerts.js";
import {useAdminClient} from "../context/auth/AdminClient.js";
import {useRealm} from "../context/realm-context/RealmContext.js";
import {prettyPrintJSON} from "../util.js";
export const PartialExportDialog = ({
  isOpen,
  onClose
}) => {
  const {t} = useTranslation();
  const {realm} = useRealm();
  const adminClient = useAdminClient();
  const {addAlert, addError} = useAlerts();
  const [exportGroupsAndRoles, setExportGroupsAndRoles] = useState(false);
  const [exportClients, setExportClients] = useState(false);
  const [isExporting, setIsExporting] = useState(false);
  const showWarning = exportGroupsAndRoles || exportClients;
  async function exportRealm() {
    setIsExporting(true);
    try {
      const realmExport = await adminClient.realms.export({
        realm,
        exportClients,
        exportGroupsAndRoles
      });
      FileSaver.saveAs(new Blob([prettyPrintJSON(realmExport)], {
        type: "application/json"
      }), "realm-export.json");
      addAlert(t("partial-export:exportSuccess"), AlertVariant.success);
      onClose();
    } catch (error) {
      addError("partial-export:exportFail", error);
    }
    setIsExporting(false);
  }
  return /* @__PURE__ */ React.createElement(Modal, {
    variant: ModalVariant.small,
    title: t("realm-settings:partialExport"),
    isOpen,
    onClose,
    actions: [
      /* @__PURE__ */ React.createElement(Button, {
        key: "export",
        "data-testid": "export-button",
        isDisabled: isExporting,
        onClick: exportRealm
      }, t("common:export")),
      /* @__PURE__ */ React.createElement(Button, {
        key: "cancel",
        "data-testid": "cancel-button",
        variant: ButtonVariant.link,
        onClick: onClose
      }, t("common:cancel"))
    ]
  }, /* @__PURE__ */ React.createElement(Stack, {
    hasGutter: true
  }, /* @__PURE__ */ React.createElement(StackItem, null, /* @__PURE__ */ React.createElement(TextContent, null, /* @__PURE__ */ React.createElement(Text, null, t("partial-export:partialExportHeaderText")))), /* @__PURE__ */ React.createElement(StackItem, null, /* @__PURE__ */ React.createElement(Checkbox, {
    id: "include-groups-and-roles-check",
    label: t("partial-export:includeGroupsAndRoles"),
    isChecked: exportGroupsAndRoles,
    onChange: setExportGroupsAndRoles
  })), /* @__PURE__ */ React.createElement(StackItem, null, /* @__PURE__ */ React.createElement(Checkbox, {
    id: "include-clients-check",
    label: t("partial-export:includeClients"),
    isChecked: exportClients,
    onChange: setExportClients
  })), showWarning && /* @__PURE__ */ React.createElement(StackItem, null, /* @__PURE__ */ React.createElement(Alert, {
    "data-testid": "warning-message",
    variant: "warning",
    title: t("partial-export:exportWarningTitle"),
    isInline: true
  }, t("partial-export:exportWarningDescription")))));
};
